import { render, staticRenderFns } from "./PlantDetail.vue?vue&type=template&id=6ba6e35b&scoped=true"
import script from "./PlantDetail.vue?vue&type=script&lang=js"
export * from "./PlantDetail.vue?vue&type=script&lang=js"
import style0 from "./PlantDetail.vue?vue&type=style&index=0&id=6ba6e35b&prod&scoped=true&lang=css"
import style1 from "./PlantDetail.vue?vue&type=style&index=1&id=6ba6e35b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba6e35b",
  null
  
)

export default component.exports